module.exports = __webpack_public_path__ + "static/media/icon-tip.366c181c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icon-tip.svg
// module id = 84
// module chunks = 0